import "./homeSection5.css";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const HomeSectionFive = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="home-main-sections"
      id="bcgap-apply-for-repayment-and-scholarship"
    >
      <div className="home-section-five">
        <div className="home-section-five-col">
          <img
            src="/images/home/image501.webp"
            alt="Apply for the Undergraduate and Parent Repayment and High-School Scholarship "
          />
          <div className="overlay"></div>
          <div className="content">
            <div>
              Apply for Parent & Undergraduate Loan Repayment, and High School
              Senior Scholarship!
            </div>
          </div>
        </div>
        <div
          className="home-section-five-col"
          onMouseEnter={() => setHovered([true, false, false])}
          onMouseLeave={() => setHovered([false, false, false])}
        >
          <a href="/bent-christy-graduate-assistance-program-for-high-school-students">
            <div className="col-wrapper">
              <div className="title">High School Senior Scholarship</div>
              <div className="content">
                As you approach the exciting milestone of high school graduation
                and preparing for college, we offer scholarships for high school
                seniors and college loan repayment assistance programs to help
                cover your college expenses.
              </div>

              <img
                src={`https://img.icons8.com/ios-filled/485364/100/circled-up-right-2.png`}
                alt="Learn more"
              />
            </div>
          </a>
        </div>
        <div
          className="home-section-five-col"
          onMouseEnter={() => setHovered([false, true, false])}
          onMouseLeave={() => setHovered([false, false, false])}
        >
          <a href="/bent-christy-graduate-assistance-program-for-college-students">
            <div className="col-wrapper">
              <div className="title">Undergraduate Loan Repayment </div>
              <div className="content">
                Are you struggling to repay your college loans? We offer
                financial assistance to graduates who completed their degrees
                within four years and are facing repayment challenges.
              </div>

              <img
                src={`https://img.icons8.com/ios-filled/FAB445/100/circled-up-right-2.png`}
                alt="Learn more"
              />
            </div>
          </a>
        </div>
        <div
          className="home-section-five-col"
          onMouseEnter={() => setHovered([false, false, true])}
          onMouseLeave={() => setHovered([false, false, false])}
        >
          <a href="/bent-christy-graduate-assistance-program-for-parents">
            <div className="col-wrapper">
              <div className="title">Parent Loan Repayment</div>
              <div className="content">
                Are you struggling to repay your child's education loans? The
                Bent Christy Graduate Assistance Program provides financial
                support to parents dealing with college loan repayment
                challenges.
              </div>
              <img
                src={`https://img.icons8.com/ios-filled/C03636/100/circled-up-right-2.png`}
                alt="Learn more"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeSectionFive;
